<div class="modal-header pb-1" [ngStyle]="{'background' : !IsfromManual && IsOutbondCall ? '#2B7FFF': !IsfromManual && !IsOutbondCall ? '#00BC7D' : ''}">
    <h4 class="modal-title" id="modal-basic-title">
        <h4>{{IsfromManual && !IsEditCallLog ? 'Add' : IsEditCallLog ? 'Update' : ''}} Call Log</h4>
    </h4>
    <div class="mr-4 pr-2 position-relative" *ngIf="!IsfromManual">
        <span class="ring_animation" [ngClass]="{'outbound': IsOutbondCall, 'inbound': !IsOutbondCall}"></span>
        <span class="p-2" style="border-radius: 5px;" [ngStyle]="{'background' : IsOutbondCall ? '#0063FA ': '#00AA71'}"><i class="fa-kit {{IsOutbondCall ? 'fa-outbound' : 'fa-inbound'}} pr-2"></i>{{IsOutbondCall ? 'Outbound to' : 'Inbound from'}} {{PhoneNumber ? (PhoneNumber | mask : "(000)000-0000") : ''}}</span>
        <span class="ml-3 cursor_pointer" (click)="miniMizeScreen()"><i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center"></i></span>
    </div>
    <button type="button" [tabindex]="-1" class="close" aria-label="Close" (click)="cancelModal()">
        <span aria-hidden="true" class="close-button">&times;</span>
    </button>
</div>
<div class="eprx--block__content block__content erx--body p-4">
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            <eprx-select [RxSelectId]="'callMode'" [LabelText]="'Call Mode'" [PlaceHolder]="'Call Mode'" [Title]="'Call Mode'"
            [ControlName]="'mode'" [FormGroupName]="callLogFG" [HasMultiple]="false" [BindLabel]="'name'"
            [BindValue]="'name'" [LabelForId]="''" [List]="callModeList" [IsDisabled]="IsfromManual ? false : true" (TriggerSelectValue)="getModDirSpckValue('Mode',$event.value)">
            </eprx-select>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            <eprx-select [RxSelectId]="'calldirection'" [LabelText]="'Call Direction'" [PlaceHolder]="'Call Direction'" [Title]="'Call Direction'"
            [ControlName]="'direction'" [FormGroupName]="callLogFG" [HasMultiple]="false" [BindLabel]="'name'" (TriggerSelectValue)="getModDirSpckValue('Direction',$event.value)"
            [BindValue]="'name'" [LabelForId]="''" [List]="callDirectionList" [IsSelectionNotClosed]="true" [IsDisabled]="IsfromManual ? false : true">
            </eprx-select>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            <eprx-input [LabelText]="'Call Duration (HH:MM:SS)'" [PlaceHolder]="'HH:MM:SS'" [MaxLength]="8" [ControlName]="'callTime'" 
            [Title]="'Call Duration'" [FormGroupName]="callLogFG" [RxSelectId]="'callduration'" [ErrorDefs]="{pattern: 'Invalid time'}" [ValidPattern]="'^(?:[01]\\d|2[0-3])[0-5]\\d[0-5]\\d$'" [MaskPattern]="'00:00:00'">
            </eprx-input>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            <eprx-date-picker *ngIf="IsfromManual" [LabelText]="'Date & Time'" [PlaceHolder]="'Date & Time'" [AutoFocus]="true" [ControlName]="'today'" [FormGroupName]="callLogFG"
            [RxSelectId]="'FromDate'" [MaxDate]="maxDate"></eprx-date-picker>
            <eprx-input *ngIf="!IsfromManual" [LabelText]="'Date & Time'" [PlaceHolder]="'Date & Time'" [ControlName]="'today'"
            [Title]="'Date & Time'" [FormGroupName]="callLogFG" [RxSelectId]="'datetime'" [IsDisabled]="true">
            </eprx-input>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            <eprx-input [LabelText]="'Extension'" [PlaceHolder]="'Extension'" [ControlName]="'extension'"
            [Title]="'Extension'" [FormGroupName]="callLogFG" [RxSelectId]="'extension'" [InputType]="'NUMBER'" [IsDisabled]="IsfromManual ? false : true">
            </eprx-input>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            <eprx-input [LabelText]="'By'" [PlaceHolder]="'By'" [ControlName]="'userInitials'"
            [Title]="'By'" [FormGroupName]="callLogFG" [RxSelectId]="'userby'" [IsDisabled]="IsfromManual ? false : true">
            </eprx-input>
        </div>
    </div>
    <div *ngIf="!IsfromManual">
        <div class="row" *ngIf="IsFrom != 'Patient'">
            <div class="pr-0" [ngClass]="Recipient?.insuName && IsFrom === 'Insurance' ? 'col-lg-4 col-md-4 col-sm-4 col-xs-4' : 'col-lg-11 col-md-11 col-sm-11 col-xs-11'">
                <label>Speaking with {{IsFrom}}</label>
                <eprx-input [LabelText]="''" [PlaceHolder]="'Speaking with'" [ControlName]="'speakingwith'"
                [Title]="'Speaking with'" [cssStyle]="true" [FormGroupName]="callLogFG" [RxSelectId]="'speakingwith'" [IsDisabled]="true">
                </eprx-input>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7 px-0" *ngIf="Recipient?.insuName && IsFrom === 'Insurance'">
                <label></label>
                <eprx-input [LabelText]="''" [PlaceHolder]="''" [ControlName]="'insuName'"
                [Title]="'Insurance Name'" [cssStyle]="true" [FormGroupName]="callLogFG" [RxSelectId]="'insuName'" [IsDisabled]="true">
                </eprx-input>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 padding_top_1_8rem" *ngIf="Recipient?.entityId">
                <i class="far fa-edit actions" title="Edit" (click)="getPresInsPhrmaDetails()"></i>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-11 col-md-11 col-sm-11 col-xs-11 pr-0 pt-2">
                <label>For Patient <span *ngIf="IsFrom != 'Patient'" class="help--text__danger">*</span></label>
                <div class="seconday-search--grid">
                    <eprx-input *ngIf="IsFrom === 'Patient'" [ControlName]="'forpatient'"
                        [Title]="'For Patient'" [cssStyle]="true" [FormGroupName]="callLogFG" [RxSelectId]="'forpatient'" [IsDisabled]="true">
                    </eprx-input>
                    <app-searchbox-global *ngIf="IsFrom != 'Patient'" [IsFocused]="isInputFocused" [SearchFor]="'Patient'" [DisableSerchFil]="true" [DisableRadioButtons]="true" [ClearInputValue]="clearpatName"
                    (SelectedPatient)="selectedPatientInfo($event)" [IsAddNew]="false"  [NotToClearSesion]="true" [InputValue]="PatientDetails?.name"></app-searchbox-global>
                    <span *ngIf="IsFrom != 'Patient' && checkPat" class="help--text__danger float-right">Required</span>
                </div>            
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 mt-1 pr-0" [ngClass]="IsFrom === 'Patient' ? 'padding_top_2rem' : !IsfromManual ? 'padding_top_2_5rem' : 'padding_top_1_5rem'" *ngIf="PatientDetails?.id">
                <i class="far fa-edit actions" title="Edit" (click)="getPatientInfo()"></i>
                <i class="far fa-history actions" title="Patient History" (click)="patientHist()"></i>
            </div>
        </div>
    </div>
    <div *ngIf="IsfromManual">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <eprx-select [RxSelectId]="'callMode'" [LabelText]="'Speaking with'" [PlaceHolder]="'Speaking with'" [Title]="'Speaking with'"
                    [ControlName]="'speakingwith'" [FormGroupName]="callLogFG" [HasMultiple]="false" [BindLabel]="'name'" [IsDisabled]="IsfromComms ? true : false"
                    [BindValue]="'id'" [LabelForId]="''" [List]="speakingWithList" (TriggerSelectValue)="getModDirSpckValue('Speaking',$event.value)" [ErrorDefs]="{required: 'Required'}" [IsRequired]="true">
                </eprx-select>
            </div>
        </div>
        <div class="row" *ngIf="Spcktype">
            <div class="pr-0" [ngClass]="Spcktype === 3 ? 'col-lg-4 col-md-4 col-sm-4 col-xs-4' : 'col-lg-11 col-md-11 col-sm-11 col-xs-11'">
                <label>{{Spcktype === 1 ? 'Patient' : Spcktype === 2 ? 'Prescriber' : Spcktype === 3 ? 'Insurance' : 'Pharmacy'}} Name <span class="help--text__danger">*</span></label>
                <div class="seconday-search--grid mb-0">
                    <eprx-input *ngIf="Spcktype === 1 && !IsfromCallLog" [ControlName]="'forpatient'"
                        [Title]="'Patient'" [cssStyle]="true" [FormGroupName]="callLogFG" [RxSelectId]="'forpatient'" [IsDisabled]="true">
                    </eprx-input>

                    <app-searchbox-global *ngIf="Spcktype === 1 && IsfromCallLog"  [IsFocused]="isInputFocused" [SearchFor]="'Patient'" [DisableSerchFil]="true" [DisableRadioButtons]="true" [ClearInputValue]="clearpatName"
                    (SelectedPatient)="selectedPatientInfo($event)" [IsAddNew]="false" [NotToClearSesion]="true"></app-searchbox-global>
                    <span *ngIf="!PatientDetails?.name && checkPat && Spcktype === 1" class="help--text__danger float-right">Required</span>
                </div>

                <div class="seconday-search--grid mb-0" *ngIf="Spcktype === 2">
                    <app-searchbox-global [SearchFor]="'Prescriber'" [DisableRadioButtons]="true" [InputValue]="IsEditCallLog ? this.Recipient?.entityName : ''" [IsAddNew]="false"
                    (SelectedPrescriber)="selctPresInsPhrm($event)" [ClearInputValue]="prescInputValue"></app-searchbox-global>
                </div>

                <div class="seconday-search--grid mb-0" *ngIf="Spcktype === 3">
                    <input type="text" #searchBoxInsType [value]="inputValue" name="searchBoxInsType" class="form-control search--input__box" id="insutype"  placeholder="To Start Search..." 
                    appChangeDebounce [ngbTypeahead]="search" [resultTemplate]="rt" [inputFormatter]="formatter" KeyUpDown (selectItem)="selctPresInsPhrm($event.item)"/>
                        <ng-template #rt let-r="result" let-t="term">
                            <div class="card patient-card secondary-patient-card" *ngIf="r">
                                <div class="row">
                                    <div class="col">
                                        <div class="row">
                                            <div class="card__subTit--head">
                                                Insurance Code:
                                            </div>
                                            <div class="card__subTit--title">
                                                {{ r?.PlanCode }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="row">
                                            <div class="card__subTit--head">
                                                Insurance Name :
                                            </div>
                                            <div class="card__subTit--title">
                                                {{ r?.InsuranceName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="row">
                                            <div class="card__subTit--head">
                                                Bin Num :
                                            </div>
                                            <div class="card__subTit--title">
                                                {{ r?.BinNum }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="row">
                                            <div class="card__subTit--head">
                                                PCN Num :
                                            </div>
                                            <div class="card__subTit--title">
                                                {{ r?.ProcessorNum }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                </div>

                <div class="seconday-search--grid mb-0" *ngIf="Spcktype === 4">
                    <app-pharmacy-suggest (selectedPharm)="selctPresInsPhrm($event)" [SourcePharmacyName]="IsEditCallLog ? this.Recipient?.entityName : ''" [frmCmms]="true" [IsFrom]="true"></app-pharmacy-suggest>
                </div>
                <span *ngIf="!Recipient?.entityName && checkPat && Spcktype != 1" class="help--text__danger float-right">Required</span>
            </div>
            <div *ngIf="Spcktype === 3" class="col-lg-7 col-md-7 col-sm-7 col-xs-7 px-0">
                <label></label>
                <input type="text" tabindex="-1" #searchBoxInsName [value]="insuName" name="searchBoxInsName" class="form-control search--input__box" readonly />
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 mt-1 pr-0" [ngClass]="Spcktype === 3 ?'padding_top_25px':'padding_top_2rem'"  *ngIf="(Spcktype===2 || Spcktype===3) && Recipient">
                <i class="far fa-edit actions" title="Edit" (click)="getPresInsPhrmaDetails()"></i>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 mt-1 pr-0" [ngClass]="IsfromCallLog ?'padding_top_2rem':'padding_top_1_5rem'" *ngIf="Spcktype===1 && PatientDetails?.id">
                <i class="far fa-edit actions" title="Edit" (click)="getPatientInfo()"></i>
                <i class="far fa-history actions" title="Patient History" (click)="patientHist()"></i>
            </div>
        </div>
        <div class="row" *ngIf="Spcktype && Spcktype!=1">
            <div class="col-lg-11 col-md-11 col-sm-11 col-xs-11 pr-0 mt-2">
                <label>For Patient <span class="help--text__danger">*</span></label>
                <div class="seconday-search--grid">
                    <app-searchbox-global [IsFocused]="isInputFocused" [SearchFor]="'Patient'" [DisableSerchFil]="true" [DisableRadioButtons]="true" [ClearInputValue]="clearpatName"
                    (SelectedPatient)="selectedPatientInfo($event)" [IsAddNew]="false"  [NotToClearSesion]="true"></app-searchbox-global>
                    <span *ngIf="!PatientDetails?.name && checkPat" class="help--text__danger float-right">Required</span>
                </div>            
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 mt-2 pr-0 padding_top_2rem" *ngIf="PatientDetails?.id">
                <i class="far fa-edit actions" title="Edit" (click)="getPatientInfo()"></i>
                <i class="far fa-history actions" title="Patient History" (click)="patientHist()"></i>
            </div>
        </div>
    </div>
    
    <div class="row" *ngIf="IsfromCallLog || IsEditCallLog">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pt-1">
            <eprx-input [LabelText]="'Call Contact'" [PlaceHolder]="'Call Contact'" [ControlName]="'phoneNumber'" [ErrorDefs]="{required: 'Required'}" [IsRequired]="IsfromCallLog || ((IsfromManual || IsEditCallLog) && Spcktype!=1) ? true : false"
            [Title]="'Call Contact'" [FormGroupName]="callLogFG" [RxSelectId]="'callcontact'" [MaskPattern]="'(000)000-0000'" [IsDisabled]="IsfromCallLog || ((IsfromManual || IsEditCallLog) && Spcktype!=1) ? false : true" [ShowMask]="true"
            (TriggerOnEnterValue)="phoneValidationCheck(callLogFG?.value?.phoneNumber)" (TriggerOnBlur) = "phoneValidationCheck(callLogFG?.value?.phoneNumber)" (TriggerOnTabbing)="phoneValidationCheck(callLogFG?.value?.phoneNumber,$event)" (TriggerOnChange)="clearTextMsg(callLogFG?.value?.phoneNumber)" [MarkAsTouched]="callLogFG['controls']?.phoneNumber?.touched">
            </eprx-input>
            <span *ngIf="errorToDisplay" [ngClass]="errorToDisplay === 'Valid!' ? 'help--text__success' : 'help--text__danger'" class="call-cont">{{errorToDisplay}}</span>
        </div>
    </div>    
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <eprx-select [RxSelectId]="'reason'" [LabelText]="'Reason(s)'" [PlaceHolder]="'Reason(s)'" [Title]="'Reason(s)'"
            [ControlName]="'reasonCodesId'" [FormGroupName]="callLogFG" [HasMultiple]="true" [AutoSelectAll]="true" [BindLabel]="'description'" [BindValue]="'reasonId'" [List]="callReasonsList" [IsRequired]="true" (TriggerSelectValue)="getModDirSpckValue('Reason',$event.value)">
            </eprx-select>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <eprx-text-area [LabelText]="'Comments'" [ControlName]="'comments'" [FormGroupName]="callLogFG" [RxSelectId]="'comments'"
            [PlaceHolder]="'Add notes about the call here...'" [Rows]="3" (TriggerOnChangeValue)="onValueChange($event)">
            </eprx-text-area>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button footer [ngClass]="(callLogFG.valid && callLogFG.controls['reasonCodesId'].value?.length) ? 'hotkey_success' : 'inactive'" appShortcutKey [AltKey]="IsEditCallLog ? 'u' : 's'" (click)="(callLogFG.valid && callLogFG.controls['reasonCodesId'].value?.length) ? saveCallLog() : ''"><span>{{IsEditCallLog ? 'U' : 'S'}}</span>{{IsEditCallLog ? 'Update' : 'Save'}}</button>
    <button footer class="hotkey_success" appShortcutKey [AltKey]="'c'" (click)="cancelModal()"><span>C</span>cancel</button>
</div>